var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34815 8.75212C6.66735 7.43287 8.23505 7.46937 9.93905 8.40382L16.31 4.87256L15.9495 2.39343L21.6063 8.05027L19.1328 7.69537L15.5959 14.0607C16.4876 15.8795 16.5669 17.3324 15.2477 18.6516C15.2477 18.6516 13.1175 16.5215 11.3586 14.7625L3.22153 20.7782L9.2191 12.6231C7.4601 10.8641 5.34815 8.75212 5.34815 8.75212Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin1);
export default __webpack_public_path__ + "static/media/pin 1.deb04f84484fef3f6cb161901de95efa.svg";
export { ForwardRef as ReactComponent };